import styled, { css } from 'styled-components';

export const GuidePopoverContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 8px;
    max-width: 240px;
    font-family: ${theme.v2.font.family.primary};
  `}
`;

export const GuidePopoverTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryMedium};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.bold};
    margin: 0;
  `}
`;

export const GuidePopoverDescription = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxs};
    margin: 0;
  `}
`;
